import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './IncomeList.css';
import { useDispatch, useSelector } from 'react-redux';
import { fetchClients } from '../../store/clientsSlice';
import { fetchIncomes, updateIncome, deleteIncome } from '../../store/incomeSlice';
import { INCOME_TAX_HEAD_OPTIONS, getOptionLabel } from '../../constants/taxOptions';

const IncomeList = () => {
  const dispatch = useDispatch();
  const { incomes, error } = useSelector((state) => state.income);
  const { clientId, financialYear } = useSelector((state) => state.app);

  const [editIndex, setEditIndex] = useState(null);
  const [editedIncome, setEditedIncome] = useState({ name: '', description: '', amount: '', taxHead: 'OTHER_SOURCES' });

  useEffect(() => {
    dispatch(fetchClients()); // Ensure clients are loaded
    dispatch(fetchIncomes());
  }, [dispatch, clientId, financialYear]);

  const handleEditClick = (index) => {
    setEditIndex(index);
    setEditedIncome({
      ...incomes[index],
      taxHead: incomes[index].taxHead || 'OTHER_SOURCES',
    });
  };

  const handleCancelEdit = () => {
    setEditIndex(null);
    setEditedIncome({ name: '', description: '', amount: '', taxHead: 'OTHER_SOURCES' });
  };

  const handleSaveEdit = (id) => {
    dispatch(updateIncome({ id, ...editedIncome }))
      .unwrap()
      .then(() => {
        setEditIndex(null);
        setEditedIncome({ name: '', description: '', amount: '', taxHead: 'OTHER_SOURCES' });
      })
      .catch((err) => {
        console.error('Error updating income', err);
      });
  };

  const handleDelete = (id) => {
    dispatch(deleteIncome(id))
      .unwrap()
      .catch((err) => {
        console.error('Error deleting income', err);
      });
  };

  return (
    <div className="income-list-page">
      <h2>Income List</h2>
      <p className="financial-page-subtitle">Keep dividend, interest, and other-source lines explicit so tax summaries remain reviewable.</p>
      <div className="financial-toolbar">
        <Link to="/add-income">
          <button className="add-income-button">Add Income</button>
        </Link>
      </div>
      {error && <p className="financial-message financial-message--error">{error}</p>}
      {incomes.length > 0 && (
        <div className="table-container">
          <table className="income-table">
            <thead>
              <tr>
                <th>Tax Head</th>
                <th>Name</th>
                <th>Description</th>
                <th>Amount</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {incomes.map((income, index) => (
                <tr key={index}>
                  {editIndex === index ? (
                    <>
                      <td>
                        <select
                          value={editedIncome.taxHead || 'OTHER_SOURCES'}
                          onChange={(e) => setEditedIncome({ ...editedIncome, taxHead: e.target.value })}
                        >
                          {INCOME_TAX_HEAD_OPTIONS.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <input
                          type="text"
                          value={editedIncome.name}
                          onChange={(e) => setEditedIncome({ ...editedIncome, name: e.target.value })}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={editedIncome.description}
                          onChange={(e) => setEditedIncome({ ...editedIncome, description: e.target.value })}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          value={editedIncome.amount}
                          onChange={(e) => setEditedIncome({ ...editedIncome, amount: e.target.value })}
                        />
                      </td>
                      <td>
                        <button className="financial-button" onClick={() => handleSaveEdit(income.id)}>Save</button>
                        <button className="financial-button financial-button--secondary" onClick={handleCancelEdit}>Cancel</button>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{getOptionLabel(INCOME_TAX_HEAD_OPTIONS, income.taxHead, 'Other Sources')}</td>
                      <td>{income.name}</td>
                      <td>{income.description}</td>
                      <td>{income.amount}</td>
                      <td>
                        {income.id&& <>
                        <button className="financial-button financial-button--secondary" onClick={() => handleEditClick(index)}>Edit</button>
                        <button className="financial-button financial-button--danger" onClick={() => handleDelete(income.id)}>Delete</button>
</>}
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default IncomeList;
